import React, { useEffect, useState } from 'react';
import { host } from '../script/variables';
import '../style/AdminHome.css';
import AdminDashboard from './AdminDashboard';


// ─── AdminDashboard placeholder ────────────────────────────────────────────────
// Replace this with your real dashboard component


const Logout = ({ onLogout }) => {
    const handleLogout = async () => {
        try {
            await fetch(`${host}/admin/logout`, {
                method: 'POST',
                credentials: 'include',   // ← sends cookie so server can clear it
            });
        }
        catch {
            // Even if the request fails, clear local state
        }
        onLogout();
    };

    return (
        <button className="ah-logout-btn" onClick={handleLogout}>
            Logout
        </button>
    );
}

// ─── LoginComponent ────────────────────────────────────────────────────────────
const LoginComponent = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError('Please fill in all fields.'); return; }

    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${host}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',          // ← sends & receives cookies
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok) {
        onLoginSuccess(data.user);
      } else {
        setError(data.msg || 'Login failed. Please try again.');
      }
    } catch {
      setError('Network error. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ah-login-wrapper">
      <div className="ah-login-card">

        <div className="ah-login-header">
          <div className="ah-login-logo">R</div>
          <h1>Admin Portal</h1>
          <p>Sign in to manage your restaurant</p>
        </div>

        <form className="ah-login-form" onSubmit={handleLogin} noValidate>
          <div className="ah-field">
            <label htmlFor="ah-email">Email address</label>
            <div className="ah-input-wrap">
              <svg className="ah-input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <input
                id="ah-email"
                type="email"
                placeholder="admin@restropilots.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div className="ah-field">
            <label htmlFor="ah-password">Password</label>
            <div className="ah-input-wrap">
              <svg className="ah-input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <input
                id="ah-password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="ah-show-pw"
                onClick={() => setShowPassword(p => !p)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {error && (
            <div className="ah-error" role="alert">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {error}
            </div>
          )}

          <button type="submit" className="ah-submit-btn" disabled={loading}>
            {loading ? <span className="ah-spinner"/> : 'Sign In'}
          </button>
        </form>

      </div>
    </div>
  );
};

// ─── AdminHome ─────────────────────────────────────────────────────────────────
const AdminHome = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true); // prevent flash of login screen

  // On mount: verify cookie session with the server
  const checkLogin = async () => {
    try {
      const res = await fetch(`${host}/admin/vlogin`, {
        method: 'GET',
        credentials: 'include',   // ← sends the httpOnly cookie automatically
      });
console.log("response from vlogin is ",res)
      if (res.ok) {
        const data = await res.json();
        setUser(data.user);
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
    } catch {
      setIsLogin(false);
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    checkLogin();
  }, []);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
    setIsLogin(true);
  };

  const handleLogout = async () => {
    try {
      await fetch(`${host}/admin/logout`, {
        method: 'POST',
        credentials: 'include',   // ← sends cookie so server can clear it
      });
    } catch {
      // Even if the request fails, clear local state
    } finally {
      setUser(null);
      setIsLogin(false);
    }
  };

  // Show a minimal loading screen while checking the session
  if (checking) {
    return (
      <div className="ah-checking">
        <span className="ah-spinner ah-spinner-lg" />
        <p>Verifying session…</p>
      </div>
    );
  }

  return (
    <div className="ah-root">
        {/* {isLogin && user && <Logout onLogout={handleLogout} />} */}
      {isLogin
        ? <AdminDashboard user={user} onLogout={handleLogout} />
        : <LoginComponent onLoginSuccess={handleLoginSuccess} />
      }
    </div>
  );
};

export default AdminHome;